import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toastr from "toastr";

function Decline(props) {
  const [show, setShow] = useState(false);
  const [comment, setComment] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onDecline = async () => {
    let data = {
      comment: comment,
    };

    if (comment == "" || !comment.trim()) {
      toastr.warning("Comment is Required!");
      return false;
    }

    props.onSubmit(data);
    handleClose();
    // let response = await declineRow(props.id, data);
    // if(response.status === 1){
    //     history.push("/health-safety-and-environment/incident-management/manage-incidents");
    // }
  };

  return (
    <>
      <span
        className={props.iconClass ? props.iconClass : "pointer btn btn-right"}
        onClick={handleShow}
      >
        {props.name ? props.name : "Decline"}
      </span>

      <Modal backdrop="static" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {props.title ? props.title : "Decline Report"}{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <label>Comment</label>
              <textarea
                className="form-control"
                placeholder="Comment"
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => onDecline()}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Decline;
